/**
 * Applies FLIP logic to the given element by removing the given
 * className to trigger the layout change. Returns an object
 * with inverted x, y, width and height values.
 *
 * @param {DOMElement} element
 * @param {string} layoutClassName
 * @returns {Object}
 */
export const flipRemove = (element, layoutClassName) => {
    console.log(layoutClassName);
    // First: get the current bounds
    const first = element.getBoundingClientRect();

    // execute the script that causes layout change
    element.classList.remove(layoutClassName);

    // Last: get the final bounds
    const last = element.getBoundingClientRect();

    // Invert: determine the delta between the 
    // first and last bounds to invert the element
    const deltaX = first.left - last.left;
    const deltaY = first.top - last.top;
    const deltaW = first.width / last.width;
    const deltaH = first.height / last.height;

    return {
        x: deltaX,
        y: deltaY,
        width: deltaW,
        height: deltaH
    }
};